import React, { useContext, useState, useMemo } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
  Spinner, // Import Spinner for loading indication
} from "reactstrap"
import apiHandler from "../../common/config/apiHandler"
import toast from "react-hot-toast"
import { DataContext } from "../../context/dataContext"
import moment from "moment"

const SendEmailModal = ({ isOpen, toggle, emailData }) => {
  const { bookingDetails, subscribeKey } = useContext(DataContext)

  const [recipientEmail, setRecipientEmail] = useState(emailData?.email)
  const [site, setSite] = useState(bookingDetails?.site?.web_address)
  const [loading, setLoading] = useState(false) // Loading state

  const handleSendEmail = async () => {
    setLoading(true) // Set loading to true when starting to send email
    try {
      const response = await apiHandler({
        endpoint2: "/crsbookings/paymentEmail",
        method: "POST",
        data: {
          key: subscribeKey,
          reference_no: bookingDetails?.reference_no,
          site_url: site,
          email: recipientEmail,
          future_date: moment().add(1, "days").format("YYYY-MM-DD HH:mm:ss"),
          user_id: bookingDetails?.bookingDetails[0]?.user_id,
        },
      })

      if (response?.response_code === 200) {
        toast.success("Email sent successfully!")
        toggle()
      } else {
        toast.error("Failed to send email. Please try again.")
      }
    } catch (error) {
      console.error("Error sending email:", error)
      toast.error("An error occurred while sending the email.")
    } finally {
      setLoading(false) // Set loading to false after the email is sent
    }
  }

  useMemo(() => {
    if (bookingDetails) {
      setSite(bookingDetails?.site?.web_address)
      setRecipientEmail(emailData?.email)
    }
  }, [bookingDetails, emailData])

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Send Email for Payment</ModalHeader>
      <ModalBody>
        <FormGroup>
          <label htmlFor="recipientEmail">Recipient Email</label>
          <Input
            type="email"
            id="recipientEmail"
            value={recipientEmail}
            onChange={e => setRecipientEmail(e.target.value)}
            className="border-secondary"
            required
          />
        </FormGroup>
        <FormGroup>
          <label htmlFor="message">Site</label>
          <Input
            type="text"
            id="message"
            value={site}
            onChange={e => setSite(e.target.value)}
            required
            className="border-secondary"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSendEmail} disabled={loading}>
          {loading ? (
            <>
              <Spinner size="sm" /> Sending...
            </>
          ) : (
            "Send Email"
          )}
        </Button>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default SendEmailModal
